import React from 'react';

import { PrimaryFilters as PrimaryFiltersProvider } from 'components/Filters';

import { useIsAllowed } from '@gogame/permissions';

import { PERMISSION_ACTION_SMART_RULES_ADMIN } from 'scenes/SmartRules/constants';
import {
  FILTER_CREATED,
  FILTER_STATUSES,
  FILTER_SHOW,
} from 'scenes/SmartRules/constants';

import Filters from './filters';

export const PRIMARY_FILTERS = [FILTER_CREATED, FILTER_STATUSES, FILTER_SHOW];

const PrimaryFilters = () => {
  const isAllowed = useIsAllowed();

  return (
    <PrimaryFiltersProvider primary={PRIMARY_FILTERS}>
      <Filters.Created />
      <Filters.CreatedBy withClear={true} />
      <Filters.Statuses withClear={true} />
      {!isAllowed(PERMISSION_ACTION_SMART_RULES_ADMIN) ? (
        <Filters.ShowMode withClear={true} />
      ) : null}
      <Filters.Type withClear={true} />
      <Filters.Affiliates dropdownWidth={'440px'} withClear={true} />
      <Filters.Channels withClear={true} />
      <Filters.Networks withClear={true} />
      <Filters.Applications withClear={true} />
      <Filters.Platforms withClear={true} />
    </PrimaryFiltersProvider>
  );
};

export default PrimaryFilters;
